import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../assets/logo/logo_original.png";

function Footer() {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const socialLinks = [
    {
      name: "Facebook",
      url: "https://www.facebook.com/chutipurbachal",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/chutiresortpurbachal?fbclid=IwY2xjawQht_FleHRuA2FlbQIxMABicmlkETF6YjYyb3EwMjZVeXBVRDAyc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHvq84A50m2OGWM8HFqZBxUtuDzUU19gmHKvl-dFsucO_a79Y4P0qyCvvFsMM_aem_8ZYxRTXbgoWsWZuU2bSWzA",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      ),
    },
    {
      name: "WhatsApp",
      url: "https://wa.me/8801709919827",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
        </svg>
      ),
    },
    {
      name: "Messenger",
      url: "https://www.facebook.com/messages/t/1645310045577712",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 0C5.373 0 0 4.974 0 11.111c0 3.498 1.744 6.614 4.469 8.654V24l4.088-2.242c1.092.3 2.246.464 3.443.464 6.627 0 12-4.974 12-11.111C24 4.974 18.627 0 12 0zm1.191 14.963l-3.055-3.26-5.963 3.26L10.732 8l3.131 3.259L19.752 8l-6.561 6.963z"/>
        </svg>
      ),
    },
    {
      name: "YouTube",
      url: "https://www.youtube.com/@chutiresortpurbachal",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
    },
    {
      name: "TripAdvisor",
      url: "https://www.tripadvisor.com/",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.006 4.295c-2.67 0-5.338.784-7.645 2.353H0l1.963 2.135a5.997 5.997 0 0 0 4.04 10.43 5.976 5.976 0 0 0 4.075-1.6L12 19.705l1.922-2.09a5.972 5.972 0 0 0 4.072 1.598 6 6 0 0 0 4.039-10.43L24 6.647h-4.361a13.98 13.98 0 0 0-7.633-2.352zm-6 7.412a3.294 3.294 0 1 1 0 6.589 3.294 3.294 0 0 1 0-6.589zm12 0a3.294 3.294 0 1 1 0 6.589 3.294 3.294 0 0 1 0-6.589zm-6-5.294c.674 0 1.338.057 1.988.167l-1.988 2.157-1.988-2.157a11.84 11.84 0 0 1 1.988-.167zM6.006 13.06a1.647 1.647 0 1 0 0 3.295 1.647 1.647 0 0 0 0-3.295zm12 0a1.647 1.647 0 1 0 0 3.295 1.647 1.647 0 0 0 0-3.295z"/>
        </svg>
      ),
    },
  ];

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "Rooms +", path: "/rooms" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <footer className="relative overflow-hidden text-white py-4 md:py-5">
      {/* Premium gradient: yellow → dark (matches header) */}
      <div className="absolute inset-0 bg-gradient-to-r from-amber-500 via-yellow-600 to-amber-900" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
      <motion.div
        className="relative max-w-7xl mx-auto px-6"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-6 lg:gap-8 mb-4 md:mb-5">
          
          {/* Column 1: About/Logo Section */}
          <motion.div variants={itemVariants} className="space-y-2 md:space-y-2.5 flex flex-col items-center md:items-start">
            <Link to="/" className="inline-block">
              <motion.img
                src={logo}
                alt="Chuti Resort Purbachal"
                className="h-16 md:h-20 object-contain"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              />
            </Link>
            <p className="text-white text-xs md:text-sm leading-relaxed">
              An exotic resort offering luxury accommodations with premium amenities in the heart of nature.
            </p>
            <div className="pt-1.5">
              <p className="text-white font-semibold text-xs md:text-sm mb-1.5">Follow Us</p>
              <div className="flex space-x-2">
                {socialLinks.map((social, index) => (
                  <motion.a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:text-amber-100 transition-colors duration-300 bg-white/10 hover:bg-white/25 p-1.5 md:p-2 rounded-full"
                    whileHover={{ scale: 1.15, rotate: 5 }}
                    whileTap={{ scale: 0.95 }}
                    title={social.name}
                  >
                    {social.icon}
                  </motion.a>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Column 2: Quick Links */}
          <motion.div variants={itemVariants} className="space-y-2 md:space-y-2.5">
            <h3 className="text-white font-bold text-base md:text-lg mb-2 md:mb-2.5 font-fancy">Quick Links</h3>
            <ul className="space-y-1.5">
              {quickLinks.map((link, index) => (
                <motion.li
                  key={index}
                  whileHover={{ x: 5 }}
                  transition={{ duration: 0.2 }}
                >
                  <Link
                    to={link.path}
                    className="text-white hover:text-amber-100 transition-colors duration-300 text-xs md:text-sm flex items-center group"
                  >
                    <span className="mr-1 md:mr-2 text-amber-200 group-hover:text-amber-100">▸</span>
                    {link.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Column 3: Contact Info */}
          <motion.div variants={itemVariants} className="space-y-2 md:space-y-2.5">
            <h3 className="text-white font-bold text-base md:text-lg mb-2 md:mb-2.5 font-fancy">Contact Us</h3>
            <ul className="space-y-2">
              <motion.li
                className="flex items-start space-x-2 text-xs md:text-sm"
                whileHover={{ x: 5 }}
                transition={{ duration: 0.2 }}
              >
                <svg className="w-4 h-4 text-amber-200 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                <div className="space-y-0.5">
                  <span className="text-white/90 block mb-1 text-[11px]">Booking:</span>
                  <a href="tel:+8801709919825" className="text-white hover:text-amber-100 transition-colors block">01709919825</a>
                  <a href="tel:+8801709919827" className="text-white hover:text-amber-100 transition-colors block">01709919827</a>
                  <a href="tel:+8801335185110" className="text-white hover:text-amber-100 transition-colors block">01335185110</a>
                  <a href="tel:+8801709919829" className="text-white hover:text-amber-100 transition-colors block">01709919829</a>
                  <span className="text-white/90 block mt-1.5 mb-0.5 text-[11px]">Investment:</span>
                  <a href="tel:+8801711074278" className="text-white hover:text-amber-100 transition-colors block">01711074278</a>
                </div>
              </motion.li>
              <motion.li
                className="flex items-start space-x-2 text-xs md:text-sm"
                whileHover={{ x: 5 }}
                transition={{ duration: 0.2 }}
              >
                <svg className="w-4 h-4 text-amber-200 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
                <div className="space-y-0.5">
                  <a href="mailto:booking@chutipurbachal.com" className="text-white hover:text-amber-100 transition-colors break-all block">booking@chutipurbachal.com</a>
                  <span className="text-white/70 text-[11px] block">(Investment: suitesale@chutipurbachal.com)</span>
                </div>
              </motion.li>
            </ul>
          </motion.div>

          {/* Column 4: Business Hours & Map Link */}
          <motion.div variants={itemVariants} className="space-y-2 md:space-y-2.5">
            <h3 className="text-white font-bold text-base md:text-lg mb-2 md:mb-2.5 font-fancy">Our Location</h3>

            {/* Resort Address */}
            <a
              href="https://www.google.com/maps/search/Chuti+Resort+Purbachal+Dhaka"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start space-x-2 group mb-2"
            >
              <svg className="w-4 h-4 mt-0.5 flex-shrink-0 text-amber-200 group-hover:text-amber-100 transition-colors" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              <span className="text-white text-xs md:text-sm group-hover:text-amber-100 transition-colors leading-relaxed">
                <strong className="text-white block mb-0.5">Resort:</strong>
                Galan, Rathura, Purbachal New Town, Gazipur, Bangladesh
              </span>
            </a>

            {/* Head Office Address */}
            <a
              href="https://maps.app.goo.gl/hXHVfgNqSfr1Paat9"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start space-x-2 group mb-2"
            >
              <svg className="w-4 h-4 mt-0.5 flex-shrink-0 text-amber-200 group-hover:text-amber-100 transition-colors" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              <span className="text-white text-xs md:text-sm group-hover:text-amber-100 transition-colors leading-relaxed">
                <strong className="text-white block mb-0.5">Head Office:</strong>
                Millenium Castle, Level: 07, House: 47, Road: 27, Block: A, Banani, Dhaka-1213
              </span>
            </a>
          </motion.div>
        </div>

        {/* Divider */}
        <motion.div
          variants={itemVariants}
          className="border-t border-white/20 pt-4 md:pt-5"
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            {/* Copyright */}
            <p className="text-xs md:text-sm text-white font-fancy text-center md:text-left">
              © {new Date().getFullYear()}{" "}
              <span className="text-white font-semibold">Chuti Resort Purbachal</span>. All rights reserved.
            </p>

            {/* Additional Links */}
            <div className="flex space-x-3 md:space-x-4 text-xs md:text-sm font-fancy">
              <motion.a
                href="#"
                className="text-white hover:text-amber-100 transition-colors"
                whileHover={{ scale: 1.05 }}
          >
            Privacy Policy
              </motion.a>
              <span className="text-white/80">|</span> 
              <motion.a
                href="#"
                className="text-white hover:text-amber-100 transition-colors"
                whileHover={{ scale: 1.05 }}
              >
                Terms & Conditions
              </motion.a>
        </div>
      </div>
        </motion.div>
      </motion.div>
    </footer>
  );
}

export default Footer;
